import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../_core/_services/api.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { MiniCountryDto } from '../../_core/_model/countries';

@Component({
  selector: 'app-admin-country-change',
  standalone: false,
  templateUrl: './admin-country-change.html',
  styleUrl: './admin-country-change.css'
})
export class AdminCountryChange implements OnInit {
  @Input() userId = '';
  @Input() currentCountryCode: string = '';
  @Input() defaultProductType = 'Wallet';

  loading: boolean = false;
  error = '';
  
  countries: MiniCountryDto[] = [];

  form!: FormGroup;
  submitted = false;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private notify: NotificationService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      countryCode: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      reason: ['Compliance override', [Validators.required, Validators.minLength(3)]]
    });


    this.loadMain();
  }

  loadMain() {
    this.loading = true;

    this.api.getMain().subscribe({
      next: (res) => {
        this.countries = res.data?.countries || [];
      },
      error: (e) => (this.error = e?.error?.Error?.Details ?? 'Failed to load main data'),
      complete: () => (this.loading = false),
    });
  }

  get f() {
    return this.form.controls;
  }

  submit() {
    this.submitted = true;

    if (!this.userId) {
      this.notify.showError('User id is required', 'Error');
      return;
    }

    if (this.form.invalid) return;

    this.saving = true;

    const payload = {
      userId: this.userId,
      countryCode: String(this.form.value.countryCode || '').toUpperCase(),
      productType: 'Wallet',
      reason: this.form.value.reason
    };

    this.api.adminChangeCountry(payload).subscribe({
      next: () => {
        this.notify.showSuccess('Country changed successfully', 'Success');
        this.form.patchValue({
          reason: 'Compliance override'
        });
        this.submitted = false;
      },
      error: (err) => {
        this.notify.showError(err?.error?.message || 'Failed to change country', 'Error');
      },
      complete: () => this.saving = false
    });
  }
}